import type { Position } from '$lib/components/map/types';
import type { LngLatBounds } from 'maplibre-gl';
import maplibregl from 'maplibre-gl';

export function getBoundsOfAnArea(bounds: LngLatBounds, paddingRatios: Record<Position, number>) {
	const sw = new maplibregl.LngLat(bounds.getSouthWest().lng, bounds.getSouthWest().lat);
	const ne = new maplibregl.LngLat(bounds.getNorthEast().lng, bounds.getNorthEast().lat);

	ne.lat += paddingRatios.top * (sw.lat - ne.lat);
	ne.lng -= paddingRatios.right * (ne.lng - sw.lng);

	sw.lat -= paddingRatios.bottom * (sw.lat - ne.lat);
	sw.lng += paddingRatios.left * (ne.lng - sw.lng);

	return new maplibregl.LngLatBounds(sw, ne);
}
